module.exports = __webpack_public_path__ + "43b012cade8883021fd7d5fd10faf245.svg";